import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React, { forwardRef, useRef } from 'react';
import styled, { css } from '@xstyled/styled-components';
import { Button as Button$1 } from 'reakit/Button';
import { filterComponent, themePath, system } from '@trybeapp/ui.system';
import { Box } from '@trybeapp/ui.box';
import { Spinner } from '@trybeapp/ui.spinner';

var _excluded = ["as", "children", "disabled", "size", "variant", "loading"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var shapeStyles = function shapeStyles(size, shape) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  padding: 0;\n  border-radius: ", ";\n"])), themePath("buttons.sizes." + size + ".height"), function (props) {
    return shape === 'circle' && props.theme.buttons.sizes[size].height;
  });
};
var StyledButton = /*#__PURE__*/styled(filterComponent(Button$1))(function (_ref) {
  var disabled = _ref.disabled,
    shape = _ref.shape,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    variant = _ref.variant;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    ", "\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    ", "\n    text-decoration: none;\n    text-align: center;\n    white-space: nowrap;\n    cursor: pointer;\n    outline: none !important; /* important for firefox */\n    border-width: ", ";\n    border-style: solid;\n    appearance: none;\n    overflow: hidden;\n    transition: ", ";\n    ", ";\n    ", ";\n\n    & > *:not(:only-child):not(:last-child) {\n      margin-right: sm;\n    }\n\n    ", ";\n\n    &[disabled] {\n      pointer-events: all !important;\n      cursor: not-allowed;\n    }\n  "])), themePath("buttons." + variant), themePath("buttons.sizes." + size), themePath('borderWidths.sm'), themePath('transitions.medium'), shape && shapeStyles(size, shape), system, !disabled && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        &:focus {\n          ", "\n        }\n        &:hover {\n          ", "\n        }\n      "])), themePath("buttons.focus." + (variant || 'primary')), themePath("buttons.hover." + (variant || 'primary'))));
});
var Button = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var as = _ref2.as,
    children = _ref2.children,
    disabled = _ref2.disabled,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'md' : _ref2$size,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'primary' : _ref2$variant,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  ref = ref || useRef();
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    disabled: loading || disabled,
    forwardedAs: as,
    ref: ref,
    size: size,
    variant: disabled ? 'disabled' : variant
  }, rest), /*#__PURE__*/React.createElement(Box, {
    style: {
      visibility: loading ? 'hidden' : null
    }
  }, children), loading && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "xs",
    mx: "sm"
  })));
});
var StyledButtonGroup = /*#__PURE__*/styled(Box)( /*#__PURE__*/css(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  > ", " {\n    &:first-child {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n\n    &:last-child {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  }\n"])), StyledButton));
Button.Group = StyledButtonGroup;

export { Button, StyledButton };
